import { useFormik } from 'formik';
import EnterEmailForm from './EnterEmailComponent';
import useSendOTP from '../../../hooks/queries/useSendOtp';
import { EMAIL_VALIDATION_SCHEMA } from '../../../yup/schemas';
import { IEmail, IEnterEmailContainerProps } from '../../../constants/types';

const EnterEmail: React.FC<IEnterEmailContainerProps> = () => {
  const { sendOtpRequest, isPending } = useSendOTP();

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: EMAIL_VALIDATION_SCHEMA,
    onSubmit: (data: IEmail) => {
      const { email } = data;
      sendOtpRequest(email);
    },
    validateOnMount: true,
    validateOnChange: true,
  });

  return (
    <EnterEmailForm
      formik={formik}
      disableSubmit={isPending}
      isPending={isPending}
    />
  );
};

export default EnterEmail;
